import { jsx as a, jsxs as s } from "react/jsx-runtime";
import g from "./components/Icons/Icons.js";
import { Theme as i } from "./types/enums.js";
import { ProgressTrackerDesign as m, ProgressTrackerStatus as n, ProgressTrackerDividerAlignment as C, ProgressTrackerDividerStatus as l } from "./components/ProgressTracker/types/enums.js";
import { IconStyle as d } from "./components/Icons/types/enums.js";
import './assets/ProgressTracker.css';const x = "#ffffff", h = "#396e75", p = "#e5fdff", f = "#546223", z = "#f0fae5", V = "#a65523", T = "#fff1e8", b = "#7f3e3e", E = "#ffe2e2", y = "#62625a", N = "#f8f8e7", R = "#38539a", D = "#707070", v = "#c8f8d1", P = "#87c9c8", O = "#5291b1", $ = "rgba(82, 145, 177, 0.1019607843)", S = "#445685", w = "#181d61", B = "rgba(24, 29, 97, 0.1019607843)", G = "#5969d6", I = "#ea999d", L = "#b6577e", A = "rgba(182, 87, 126, 0.1019607843)", W = "#7e3e80", U = "#1e247f", M = "rgba(30, 36, 127, 0.1019607843)", Y = "#da7600", j = "#107f47", F = "#d91734", H = "_html_nxxn5_46", q = "_hide_nxxn5_108", J = "_completed_nxxn5_122", K = "_final_nxxn5_125", Q = "_track_nxxn5_182", X = "_future_nxxn5_276", e = {
  amwayWhite: x,
  darkBlue: h,
  lightBlue: p,
  darkGreen: f,
  lightGreen: z,
  darkOrange: V,
  lightOrange: T,
  darkRed: b,
  lightRed: E,
  darkYellow: y,
  lightYellow: N,
  darkPurple: R,
  darkGrayOnWhite: D,
  dataVizColor1: v,
  dataVizColor2: P,
  dataVizColor3: O,
  dataVizColor3Background: $,
  dataVizColor4: S,
  dataVizColor5: w,
  dataVizColor5Background: B,
  dataVizColor6: G,
  dataVizColor7: I,
  dataVizColor8: L,
  dataVizColor8Background: A,
  dataVizColor9: W,
  dataVizColor10: U,
  dataVizColor10Background: M,
  dataVizAlertOrange: Y,
  dataVizSuccessGreen: j,
  dataVizWarningRed: F,
  "no-visible": "_no-visible_nxxn5_42",
  html: H,
  "progress-tracker": "_progress-tracker_nxxn5_80",
  "progress-tracker-stage": "_progress-tracker-stage_nxxn5_88",
  "progress-tracker-stage-left": "_progress-tracker-stage-left_nxxn5_95",
  "progress-tracker-bridge": "_progress-tracker-bridge_nxxn5_103",
  hide: q,
  "progress-tracker-node": "_progress-tracker-node_nxxn5_111",
  completed: J,
  final: K,
  "current-stage": "_current-stage_nxxn5_128",
  "inner-circle": "_inner-circle_nxxn5_132",
  "progress-tracker-stage-right": "_progress-tracker-stage-right_nxxn5_138",
  "progress-tracker-stage-title": "_progress-tracker-stage-title_nxxn5_157",
  "progress-tracker-horizontal": "_progress-tracker-horizontal_nxxn5_161",
  "stage-container": "_stage-container_nxxn5_171",
  track: Q,
  "stage-content-container": "_stage-content-container_nxxn5_186",
  "stage-content-title": "_stage-content-title_nxxn5_193",
  "stage-body": "_stage-body_nxxn5_203",
  "completed-gray": "_completed-gray_nxxn5_221",
  future: X,
  "dashed-divider": "_dashed-divider_nxxn5_300",
  "completed-divider": "_completed-divider_nxxn5_303",
  "bottom-divider-alignment": "_bottom-divider-alignment_nxxn5_315",
  "skeleton-loading": "_skeleton-loading_nxxn5_1"
}, _ = (o, r) => r || (o === n.CURRENT || o === n.COMPLETED ? d.SOLID : d.REGULAR), Z = (o, r) => r || (o === n.COMPLETED ? l.COMPLETED_DIVIDER : l.DASHED_DIVIDER), k = (o, r) => {
  if (r)
    return r;
  switch (o) {
    case n.COMPLETED:
      return e.amwayWhite;
    case n.CURRENT:
      return e.darkPurple;
    default:
      return e.darkGrayOnWhite;
  }
}, { CURRENT: rr, COMPLETED: er, COMPLETED_GRAY: tr, FUTURE: or } = n, u = {
  [rr]: "circle",
  [er]: "check",
  [tr]: "check",
  [or]: "circle"
}, ar = ({ stages: o }) => /* @__PURE__ */ a("section", { className: e["progress-tracker"], "data-testid": "progress-tracker", "data-pod-name": "fwk", children: o.map((r, t) => {
  var c;
  return /* @__PURE__ */ s("section", { className: e["progress-tracker-stage"], children: [
    /* @__PURE__ */ s("div", { className: e["progress-tracker-stage-left"], children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: `${e["progress-tracker-node"]} ${e[r.status]} ${t === o.length - 1 && e.final}`,
          "data-testid": "progress-tracker-node",
          "data-pod-name": "fwk",
          style: {
            backgroundColor: r.bgColor,
            borderColor: r.borderColor
          },
          children: r.status === n.CURRENT && !((c = r.iconName) != null && c.length) ? /* @__PURE__ */ a(
            "div",
            {
              style: { backgroundColor: k(r.status, r.iconColor) },
              className: e["inner-circle"],
              "data-testid": "current-status-node",
              "data-pod-name": "fwk"
            }
          ) : /* @__PURE__ */ a(
            g,
            {
              theme: t === o.length - 1 ? i.WHITE : i.GRAY,
              iconName: r.iconName || u[r.status],
              iconStyle: _(r.status, r.iconStyle),
              style: { color: r.iconColor }
            }
          )
        }
      ),
      /* @__PURE__ */ a("div", { className: `${e["progress-tracker-bridge"]} ${t === 0 ? e.hide : ""}` })
    ] }),
    /* @__PURE__ */ s(
      "div",
      {
        className: `${e["progress-tracker-stage-right"]} ${e[r.status]} ${r.status === n.COMPLETED && t === o.length - 1 && e.final}`,
        style: {
          color: r.textColor
        },
        children: [
          /* @__PURE__ */ a("span", { className: `${e["progress-tracker-stage-title"]}`, children: r.title }),
          r.desc
        ]
      }
    )
  ] }, r.status);
}) }), nr = ({
  stages: o,
  dividerAlignment: r = C.DEFAULT
}) => /* @__PURE__ */ a(
  "section",
  {
    className: `${e["progress-tracker-horizontal"]} ${e[r]} ${r}`,
    "data-testid": "progress-traker-horizontal-testid",
    "data-pod-name": "fwk",
    children: o.map((t) => {
      const c = Z(t.status, t.dividerStatus);
      return /* @__PURE__ */ s("div", { className: `${e["stage-container"]} ${e[t.status]}`, children: [
        /* @__PURE__ */ s(
          "div",
          {
            className: e["stage-body"],
            style: {
              backgroundColor: t.bgColor,
              borderColor: t.borderColor,
              color: t.textColor
            },
            children: [
              /* @__PURE__ */ a(
                g,
                {
                  iconName: t.iconName || u[t.status],
                  iconStyle: _(t.status, t.iconStyle),
                  style: { color: k(t.status, t.iconColor) }
                }
              ),
              /* @__PURE__ */ s("section", { className: e["stage-content-container"], children: [
                /* @__PURE__ */ a("article", { className: e["stage-content-title"], children: t.title }),
                /* @__PURE__ */ a("article", { children: t.desc })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a("div", { className: `${e.track} ${e[c]}` })
      ] }, `${t.status}-${t.title}`);
    })
  }
), sr = (o) => {
  const r = !o.progressTrackerDesign || o.progressTrackerDesign === m.VERTICAL ? ar : nr;
  return /* @__PURE__ */ a(r, { ...o });
};
sr.displayName = "ProgressTracker";
export {
  sr as P,
  e as s
};
//# sourceMappingURL=ProgressTracker-44d027ff.mjs.map
